export const constants = {
  driverApi: import.meta.env.VITE_DRIVER_API,
  basename: import.meta.env.VITE_BASENAME,
  mode: import.meta.env.MODE,
  isProd: import.meta.env.MODE === 'production',
  isDev: import.meta.env.MODE === 'development',
  allocabAccountKey: import.meta.env.VITE_ALLOCAB_ACCOUNT_KEY,
};
